import React, { useEffect, useState } from "react";
import Header2 from "../Header2/Header2";

interface Navbar2Props {
  hclass?: string;
}

const Navbar2: React.FC<Navbar2Props> = ({ hclass }) => {
  const [scroll, setScroll] = useState<number>(0);

  useEffect(() => {
    const handleScroll = () => setScroll(document.documentElement.scrollTop);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const className = scroll > 80 ? "fixed-navbar active" : "fixed-navbar";

  return (
    <div className={className}>
      <Header2 hclass={hclass} />
    </div>
  );
};

export default Navbar2;
